import { ViewChild,Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { PanicDetailsComponent } from '../panic-details/panic-details.component';


@Component({
    selector: 'panic-alert',
    templateUrl: './panic-alert.component.html',
    styleUrls: ['./panic-alert.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PanicAlertComponent implements OnInit {

    openedPanic: boolean = false;
    openResolveForm: boolean = false;
    @Input() isResolver: boolean;
    @ViewChild("panicDetails") panicDetailsComponent: PanicDetailsComponent;
    @Input() alertData: any;

    constructor(private ref: ChangeDetectorRef) { }

    ngOnInit() { }

    openPanic() {
        this.openedPanic = !this.openedPanic;
        this.ref.detectChanges();
        this.panicDetailsComponent.updateMap();
    }

    toggleResolveForm(state: boolean) {
        this.openResolveForm = state;
        this.ref.detectChanges();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/PanicAlert/panic-alert/panic-alert.component.ts